import MMap from './components/MMap';

const element = document.querySelector('.o-trip-request__map');
if (element) {
  window.mMap = new MMap(element);
}
